import { render, staticRenderFns } from "./modalBillableTariffAdd.vue?vue&type=template&id=3d5d591f&scoped=true"
import script from "./modalBillableTariffAdd.vue?vue&type=script&lang=js"
export * from "./modalBillableTariffAdd.vue?vue&type=script&lang=js"
import style0 from "./modalBillableTariffAdd.vue?vue&type=style&index=0&id=3d5d591f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d591f",
  null
  
)

export default component.exports